import { render, staticRenderFns } from "./TransactionsDash.vue?vue&type=template&id=5a75631e"
import script from "./TransactionsDash.vue?vue&type=script&lang=js"
export * from "./TransactionsDash.vue?vue&type=script&lang=js"
import style0 from "./TransactionsDash.vue?vue&type=style&index=0&id=5a75631e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports